module.exports = __webpack_public_path__ + "img/海量模版.f77f056c.gif";